export default __webpack_public_path__ + "static/media/rules-coffee.bc68d6bb.svg";